module.exports = __webpack_public_path__ + "static/media/yuan.576456d6.dsv";


//////////////////
// WEBPACK FOOTER
// ./src/data/yuan.dsv
// module id = 228
// module chunks = 0